import { useState } from "react";
import ATMPageHeader from "src/components/UI/atoms/ATMPageHeader/ATMPageHeader";
import ATMTable, {
  columnTypes,
} from "src/components/UI/atoms/ATMTable/ATMTable";
import EditUpcomingInstallmentWrapper from "../Edit/EditUpcomingInstallmentWrapper";


type Props = {
  columns: columnTypes[];
  rows: any[];
  paginationProps: {
    isTableLoading: boolean;
    totalItems: number;
    page: number;
    rowsPerPage: number;
    searchValue: string;
    setPage: (newPage: number) => void;
    setRowsPerPage: (newLimit: number) => void;
    setSearchValue: (newValue: string) => void;
  };
};

const UpcomingInstallmentListing = ({
  columns,
  rows,
  paginationProps: {
    isTableLoading,
    totalItems,
    page,
    rowsPerPage,
    searchValue,
    setPage,
    setRowsPerPage,
    setSearchValue,
  },
}: Props) => {
  const [isOpenUpdateInstallmentForm, setIsOpenUpdateInstallmentForm] =
    useState(false);

  const [batchId, setBatchId] = useState("");

  const batchWiseInstallments = rows.reduce((result: any[], installment) => {
    const existBatchIndex = result?.findIndex(
      (el: any) => el?.batchId === installment?.batchId
    );

    if (existBatchIndex === -1) {
      return [
        ...result,
        {
          batchName: installment?.batchLabel,
          batchId: installment?.batchId,
          installments: [installment],
        },
      ];
    }

    let cloneResult = result;
    cloneResult[existBatchIndex] = {
      ...cloneResult[existBatchIndex],
      installments: [
        ...cloneResult[existBatchIndex]?.installments,
        installment,
      ],
    };

    return cloneResult;
  }, []);

  return (
    <div className="flex flex-col h-full overflow-hidden gap-2">
      {/* Page Header */}
      <div>
        <ATMPageHeader
          pageTitle="Upcoming Installments"
          hideAddButton
          hideSearchBox
        />
      </div>

      {/* Batch Wise Installments */}
      <div className="grid grid-cols-12 gap-4">
        {batchWiseInstallments?.map((installment) => (
          <div
            key={installment?.batchId}
            className="xl:col-span-6 col-span-full flex flex-col gap-2 max-h-[300px] border border-slate-300 p-4 rounded shadow"
          >
            {/* Page Header */}
            <div className="">
              <ATMPageHeader
                pageTitle={installment?.batchName}
                searchValue={searchValue}
                onSearchChange={setSearchValue}
              
                buttonProps={{
                  btnName: "Update Installment",
                  onClick: () => {
                    setIsOpenUpdateInstallmentForm(true);
                    setBatchId(installment?.batchId);
                  },
                }}
                hideSearchBox
              />
            </div>

            {/* Table */}
            <div className="flex-1 overflow-hidden flex flex-col border border-slate-300 rounded">
              <ATMTable
                columns={columns}
                rows={installment?.installments}
                rowExtraClasses={() => "min-h-[40px]"}
                isLoading={isTableLoading}
                extraClasses="border-none overflow-auto"
              />
            </div>

            {isOpenUpdateInstallmentForm ? (
              <EditUpcomingInstallmentWrapper
                batchId={batchId}
                onClose={() => setIsOpenUpdateInstallmentForm(false)}
              />
            ) : null}
          </div>
        ))}
      </div>
    </div>
  );
};

export default UpcomingInstallmentListing;
